export default {
  data () {
    return {
      recaptchaKey: this.$recaptchaKey,
      recaptchaEnterprise: this.$recaptchaEnterprise,
      recaptchaError: false,
      recaptchaResponse: '',
      isCaptchaRendered: false
    }
  },
  async mounted () {
    if (this.recaptchaKey) {
      if (document.querySelector('body').setActive !== undefined) {
        document.querySelector('body').setActive()
      }
      window.renderRecaptcha = this.renderRecaptcha.bind(this)
      await this.checkCaptchaStatus()
      if (this.isCaptchaRendered) {
        if (typeof window.grecaptcha !== 'undefined') {
          this.renderRecaptcha()
        } else {
          this.loadRecaptchaScript()
        }
      }
    }
  },
  methods: {
    async checkCaptchaStatus () {
      const action = this.captchaAction || 'login'
      try {
        const response = await fetch(`/captcha-status/${action}`, {
          method: 'GET',
          credentials: 'same-origin'
        })
        if (response.ok) {
          const shouldRender = await response.json()
          this.isCaptchaRendered = shouldRender === true
        }
      } catch (e) {
        this.isCaptchaRendered = false
      }
    },
    loadRecaptchaScript () {
      if (typeof window.grecaptcha !== 'undefined') {
        return
      }
      const recaptchaScript = document.createElement('script')
      const scriptUrl = this.$recaptchaEnterprise
        ? `https://www.google.com/recaptcha/enterprise.js?onload=renderRecaptcha&render=explicit&hl=${this.locale.split('-')[0]}`
        : `https://www.google.com/recaptcha/api.js?onload=renderRecaptcha&render=explicit&hl=${this.locale.split('-')[0]}`
      recaptchaScript.setAttribute('src', scriptUrl)
      recaptchaScript.setAttribute('defer', 'true')
      recaptchaScript.setAttribute('async', 'true')
      document.head.appendChild(recaptchaScript)
    },
    renderRecaptcha () {
      this.$nextTick(() => {
        const containerId = this.captchaContainerId || 'recaptcha'
        const api = window.grecaptcha.enterprise || window.grecaptcha
        if (!api) return
        api.render(containerId, {
          sitekey: this.recaptchaKey,
          callback: (res) => {
            if (res) {
              this.recaptchaResponse = res
            }
            this.checkRecaptchaError()
          },
          'expired-callback': this.resetRecaptcha
        })
      })
    },
    resetRecaptcha () {
      this.recaptchaError = false
      this.recaptchaResponse = ''
      const api = window.grecaptcha.enterprise || window.grecaptcha
      api.reset()
    },
    checkRecaptchaError () {
      this.recaptchaError = this.recaptchaResponse === ''
    }
  },
  computed: {
    locale () {
      return this.$root.$i18n.locale
    }
  },
  watch: {
    submit () {
      this.checkRecaptchaError()
    },
    loginStep (val) {
      if (val === 'password' && this.isCaptchaRendered) {
        this.renderRecaptcha()
      }
    }
  }
}
